import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ModelVariantUnits from './ModelVariantUnits';
import { getModelVariantUnits, getUserProfileWidget } from '../../selectors/index';
import {
  getModelVariantUnitsThunk,
  saveModelVariantUnitsThunk,
  setModelVariantUnitsChangeThunk,
  setModelVariantUnitsScreenStatusThunk
} from '../../actions/modelVariant';

const mapStateToProps = state => {
  return {
    modelVariantUnitManager: getModelVariantUnits(state),
    userProfileWidgets: getUserProfileWidget(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getModelVariantUnits: item => getModelVariantUnitsThunk(item, 'MODELVARIANT_UNIT_VIEW'),
      saveModelVariantUnits: modelvariantunits => saveModelVariantUnitsThunk(modelvariantunits, 'MODELVARIANT_UNIT_ALLOCATE'),
      setModelVariantUnitsChange: selectedModelversionunits => setModelVariantUnitsChangeThunk(selectedModelversionunits),
      setModelVariantUnitsScreenStatus: status => setModelVariantUnitsScreenStatusThunk(status)
      
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ModelVariantUnits);
